import { View, ViewProps, ViewStyle } from 'react-native'
import { useTheme } from '../../../hooks/theme.hook'

interface RowProps extends ViewProps {
  children: React.ReactNode
  justifyContent?: ViewStyle['justifyContent']
  alignItems?: ViewStyle['alignItems']
  gap?: number
  columnGap?: number
  style?: ViewStyle
  flex?: number
  wrap?: boolean
}

export const Row: React.FC<RowProps> = ({
  children,
  justifyContent = 'flex-start',
  alignItems = 'center',
  columnGap = 0,
  gap = 0,
  flex,
  style,
  wrap,
  ...viewProps
}) => {
  const theme = useTheme()
  const resolvedGap = theme.spacing(gap || columnGap)
  return (
    <View
      style={[
        {
          display: 'flex',
          flexDirection: 'row',
          justifyContent,
          alignItems,
          gap: resolvedGap,
          // Do not set columnGap when 0 — RN treats it as explicit and it can
          // block horizontal spacing from `gap` or from styles merged after this.
          ...(columnGap ? { columnGap: theme.spacing(columnGap) } : {}),
          flex,
          flexWrap: wrap ? 'wrap' : 'nowrap',
        },
        style,
      ]}
      {...viewProps}
    >
      {children}
    </View>
  )
}

export default Row
